import ReactGA from "react-ga4";


export const analyticsService = {


  handleVCO_Cert_DirectLink_QRClicked: () => {
    ReactGA.event({
      category: "VCO_Cert_DirectLink_QR",
      action: "Cert Direct Link/QR ",
      label: "Direct Cert Link/QR",
      value: 1,
      nonInteraction: false,
    })
  },
  handleVCO_Desig_DirectLink_QRClicked: () => {
    ReactGA.event({
      category: "VCO_Desig_DirectLink_QR",
      action: "Desig Direct Link/QR",
      label: "Direct Desig Link/QR",
      value: 1,
      nonInteraction: false,
    })
  },
  handleVCO_Desig_SMSClicked: () => {
    ReactGA.event({
      category: "VCO_Desig_SMS",
      action: "Desig SMS Clicked",
      label: "Desig SMS",
      value: 1,
      nonInteraction: false,
    })
  },

  handleVCO_Desig_WhatsAppClicked: () => {
    ReactGA.event({
      category: "VCO_Desig_WhatsApp",
      action: "Desig WhatsApp Clicked",
      label: "Desig WhatsApp",
      value: 1,
      nonInteraction: false,
    })
  },

  handleVCO_Desig_EmailClicked: () => {
    ReactGA.event({
      category: "VCO_Desig_Email",
      action: "Desig Email Clicked",
      label: "Desig Email",
      value: 1,
      nonInteraction: false,
    })
  },

  handleVCO_Cred_DirectLink_QRClicked: () => {
    ReactGA.event({
      category: "VCO_Cred_DirectLink_QR",
      action: "Cred Direct Link/QR Clicked",
      label: "Cred Direct Link/QR",
      value: 1,
      nonInteraction: false,
    })
  },

  handleVCO_Cred_SMSClicked: () => {
    ReactGA.event({
      category: "VCO_Cred_SMS",
      action: "Cred SMS Clicked",
      label: "Cred SMS",
      value: 1,
      nonInteraction: false,
    })
  },

  handleVCO_Cred_WhatsAppClicked: () => {
    ReactGA.event({
      category: "VCO_Cred_WhatsApp",
      action: "Cred WhatsApp Clicked",
      label: "Cred WhatsApp",
      value: 1,
      nonInteraction: false,
    })
  },

  handleVCO_Cred_EmailClicked: () => {
    ReactGA.event({
      category: "VCO_Cred_Email",
      action: "Cred Email Clicked",
      label: "Cred Email",
      value: 1,
      nonInteraction: false,
    })
  },

  handleVCO_Cred_LinkedInClicked: () => {
    // ReactGA.event({
    //   category: "VCO_Cred_LinkedIn",
    //   action: "Cred LinkedIn Clicked",
    //   label: "Cred LinkedIn",
    //   value: 1,
    //   nonInteraction: false,
    // })
  },

  handleVCO_Cred_FacebookClicked: () => {
    ReactGA.event({
      category: "VCO_Cred_Facebook",
      action: "Cred Facebook Clicked",
      label: "Cred Facebook",
      value: 1,
      nonInteraction: false,
    })
  },

  handleVCO_Cert_SMSClicked: () => {
    ReactGA.event({
      category: "VCO_Cert_SMS",
      action: "Cert SMS Clicked",
      label: "Cert SMS",
      value: 1,
      nonInteraction: false,
    })
  },

  handleVCO_Cert_WhatsAppClicked: () => {
    ReactGA.event({
      category: "VCO_Cert_WhatsApp",
      action: "Cert WhatsApp Clicked",
      label: "Cert WhatsApp",
      value: 1,
      nonInteraction: false,
    })
  },

  handleVCO_Cert_EmailClicked: () => {
    ReactGA.event({
      category: "VCO_Cert_Email",
      action: "Cert Email Clicked",
      label: "Cert Email",
      value: 1,
      nonInteraction: false,
    })
  },

  handleExcelExportClicked: () => {
    ReactGA.event({
      category: "Bulk_Upload_Export_Results",
      action: "Bulk Upload Export",
      label: "Excel Export",
      value: 1,
      nonInteraction: false,
    })
  },

  handleVCO_Cert_LinkedInClicked: () => {
    // ReactGA.event({
    //   category: "VCO_Cert_LinkedIn",
    //   action: "Cert LinkedIn Clicked",
    //   label: "Cert LinkedIn",
    //   value: 1,
    //   nonInteraction: false,
    // })
  },

  handleVCO_Cert_FacebookClicked: () => {
    ReactGA.event({
      category: "VCO_Cert_Facebook",
      action: "Cert Facebook Clicked",
      label: "Cert Facebook",
      value: 1,
      nonInteraction: false,
    })
  },

  handleVCO_Desig_LinkedInClicked: () => {
    // ReactGA.event({
    //   category: "VCO_Desig_LinkedIn",
    //   action: "Desig LinkedIn Clicked",
    //   label: "Desig LinkedIn",
    //   value: 1,
    //   nonInteraction: false,
    // })
  },

  handleVCO_Desig_FacebookClicked: () => {
    ReactGA.event({
      category: "VCO_Desig_Facebook",
      action: "Desig Facebook Clicked",
      label: "Desig Facebook",
      value: 1,
      nonInteraction: false,
    })
  },

};